import Vue from "vue";
import "./plugins/bootstrap-vue";
import App from "./App.vue";
import router from "./router";
// import page from "page";

Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");

// const app = new Vue({
//   el: "#app",
//   data: {
//     ViewComponent: { render: h => h("div", "loading...") }
//   },
//   render(h) {
//     return h(this.ViewComponent);
//   }
// });

// Object.keys(routes).forEach(route => {
//   const Component = require("./views/" + routes[route] + ".vue");
//   page(route, () => (app.ViewComponent = Component));
// });
// page("*", () => (app.ViewComponent = require("./views/404.vue")));
// page();
